module.exports = __webpack_public_path__ + "img/canbadge_hachikaku_58mm_line.df0c257c.png";